import { render, staticRenderFns } from "./activeCompanyCard.vue?vue&type=template&id=0fc736f4"
import script from "./activeCompanyCard.vue?vue&type=script&lang=js"
export * from "./activeCompanyCard.vue?vue&type=script&lang=js"
import style0 from "./activeCompanyCard.vue?vue&type=style&index=0&id=0fc736f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports